import React from 'react'

const SettingsContainer: React.FC = () => {
  return (
    <div className="flex sm:flex-col sm:gap-y-[27px]  h-screen ">setttings</div>
  )
}
export default SettingsContainer
